import Utils from '../utils/utils';
import emitter from 'tiny-emitter/instance';

class Cookiebar{

    constructor()
    {

        this.$bar = document.querySelector('.cookieBar')
        this.$refuseCookie = document.querySelector('.cookie-controls--refuse')
        this.$acceptCookie = document.querySelector('.cookie-controls--accept')
        this.$buttons = document.querySelectorAll('.cookie-controls--button')
        this.$buttonsBtnOpen = document.querySelector('.cookieBtnOpen a')

        let  cookieVal =  Utils.getCookie('cookieBar')
        /* check if cookie exist */
        if (cookieVal === '') {
            this.open()
        } else if (cookieVal === 'yes') {
            emitter.emit('cookie::Enabled');
        } else {
            // this.close()
            //console.log('🚧🚧 NO')
        }

        this.bindEvents()
    }

    bindEvents()
    {
        this.$refuseCookie.addEventListener('click',()=>{
            this.close() // val
            Utils.setCookie('cookieBar', 'no', 1);
            emitter.emit('cookie::Disabled')
        })

        this.$acceptCookie.addEventListener('click',()=>{
            this.close()
            Utils.setCookie('cookieBar', 'yes', 1);
            emitter.emit('cookie::Enabled')

        })

      if(this.$buttonsBtnOpen){
        this.$buttonsBtnOpen.addEventListener('click',(e)=>{
          e.preventDefault();
          this.open();
        });
      }

    }

    close()
    {
        this.$bar.classList.add('cookieBar_closed')
    }

    open()
    {
        this.$bar.classList.remove('cookieBar_closed')
    }

}

export default Cookiebar



// WEBPACK FOOTER //
// ./scripts/interface/cookieBar.js